import React, { ReactElement } from 'react';
import { t } from '@sm/intl';
import { Container } from '@sm/wds-react';
import COPY from '~app/pages/EnterpriseThankYouV2/copy';
import Logo from './components/Logo';
import Text from './components/Text';
import { HeaderPropsType, HeaderTypeEnum } from './types';
import './header.scss';

const Header = ({ premium, headerLogoUrl, headerText, endPageIsEnabled }: HeaderPropsType): ReactElement => {
  const headerType = premium && endPageIsEnabled ? HeaderTypeEnum.PREMIUM : HeaderTypeEnum.STANDARD;

  const logo = {
    url: headerLogoUrl,
    altText: t(COPY.LOGO_PLACEHOLDER),
  };

  return (
    <Container className="sm-header__outline">
      <Logo headerType={headerType} altText={logo.altText} url={logo.url} />
      <Text text={headerText} headerType={headerType} />
    </Container>
  );
};

export default Header;
